import { createSelector } from 'reselect';
import RecalculateTasksColumns from '../../containers/RecalculateTasksColumns';
import TableDefinitions from '../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.RECALCULATE_TASKS_LIST.isLoading;
export const getData = TableDefinitions.RECALCULATE_TASKS_LIST.getDataFunction();
export const getColumns = createSelector(getData, RecalculateTasksColumns);
